import logger from '3-foundation/Logging/logger';

interface Props {
	content: {
		contentType: 'bookmarkMenu';
		properties: {
			kicker: string | null;
			heading: string | null;
			text: { markup: string | null } | null;
		};
	};
}

export const mapBookmarkMenu = ({ content }: Props): Content.BookmarkMenu => {
	try {
		return {
			documentType: content?.contentType,
			content: {
				kicker: content?.properties?.kicker ?? null,
				heading: content?.properties?.heading ?? null,
				text: content?.properties?.text?.markup ?? null,
			},
		};
	} catch (e) {
		logger.error('Could not map BookmarkMenu', e);
		throw new Error('Could not map BookmarkMenu', e);
	}
};
